import { Deserializable } from '../protocols/deserializable';
import { FundType } from '../transactions/fund-type';

export class WithdrawalInstruction implements Deserializable {
  public fundId!: number;
  public percentage!: number;
  public fund!: FundType;
  public fundBalance!: number;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.fund) {
      this.fund = Deserialize.instanceOf(FundType, this.fund);
    }
  }
}
